import {WidgetState} from '../../types';

export const getAveragePlayTimeState = (state): WidgetState => {
    return state.get('averagePlayTime').toJS();
};
